import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { constants } from 'src/app/constants';
import { GeneralService } from 'src/app/api/config/general.service';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { ClientExtendsComponent } from 'src/app/sale/client/client-extends/client-extends.component';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
import { OpeningService } from 'src/app/api/money/opening.service';
import { AmountTextService } from 'src/app/utils/amount-text.service';
import { HttpHeaders } from '@angular/common/http';
import { IncomeService } from 'src/app/api/money/income.service';
import SwalAlert from 'src/app/utils/swalalert';
import { VoucherService } from 'src/app/api/billing/voucher.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-voucher-form',
  templateUrl: './voucher-form.component.html',
  styleUrls: ['./voucher-form.component.css']
})
export class VoucherFormComponent implements OnInit {
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;

  private thisComponent: VoucherFormComponent;

  branchofficeSlug: string = '';
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  isRuc: boolean = false;

  fecha_actual:any = moment().format('YYYY-MM-DD');
  transaction_cash = constants.SALE.TRANSACTIONS[0].id;
  transaction_credit = constants.SALE.TRANSACTIONS[1].id;
  transaction_credit_parts = constants.SALE.TRANSACTIONS[2].id;

  // money box
  check_moneybox: boolean = false;
  boxselected: any = null;
  moneybox: any = null;
  validatealert: boolean = false;

  // variables
  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_recibo: any = null;
  typedocument_ruc: any = null;

  transactions: any = [];
  currencies: any = [];
  paymentmethods: any = [];
  accountbanks: any = [];
  typevouchers: any = [];
  series: any = [];

   // array variables
  detail_credit_parts: any = [];

  // obj variables
  currencySelected: any = {};
  paymentMethodSelected: any = {};
  typeVoucherSelected: any = null;
  serieSelected: any = null;
  clientSelected: any = null;
  transactionSelected: any = 1; //por defecto tipo transaccion al contado
  warehousesSelected: any = null;
  fileUrlImage: any = null;

  // variables save
  segment_prices: any = constants.PRODUCT.SEGMENTPRICES;
  type_products: any = constants.PRODUCT.TYPEPRODUCT;
  quantity_default: number = 1;
  detail_items: any = [];

  // totales:
  subtotal: any = 0;
  total_igv: any = 0;
  total_amount: any = 0;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private incomeService: IncomeService,
    private voucherService: VoucherService,
    private openingService: OpeningService,
    private globalService: GlobalService,
    private generalService: GeneralService,
    private warehouseService: WarehouseService,
    private route: ActivatedRoute,
    public toolsService: ToolsService,
    private amountTextService: AmountTextService,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService,
    private alert: SwalAlert
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_recibo = this.toolsService.searchObjByKey(
      'RECIBO_INGRESO',
      constants.SALE.VOUCHER
    );

    this.typedocument_ruc = constants.CLIENT.TYPE_DOCUMENT.RUC;

    this.item = this.fb.group({
      typetransaction_id: [null, [Validators.required]],
      client_id: [null, [Validators.required]],
      branchoffice_id: [null],
      currency_id: [null, [Validators.required]],
      paymentmethod_id: [
        constants.paymentmethod_init_id,
        [Validators.required]
      ],
      accountbank_id: [null],
      gloss: [null],
      amount: [null],
      reference_operation: [null],
      text_amount: [null],
      observation: [null],
      typevoucher_id: [null],
      serie: [null],
      date_expiration: [this.fecha_actual],
    });
  }

  ngOnInit() {
    this.checkBoxSelected();
    this.getWarehousePrincipal();
    this.getTypeVoucherSale();
    this.getCurrencies();
    this.getPaymentmethods();
    this.getTypeTransactions();
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  checkBoxSelected() {
    let val_params = '';
    this.openingService.getCheckBoxSlected(val_params).subscribe({
      next: (data: any) => {
        if (!_.isNull(data.data)) {
          this.boxselected = data.data;
          this.getBoxOpening();
        }
      }
    });
  }

  getBoxOpening() {
    this.openingService.getBoxOpening(this.boxselected.id).subscribe({
      next: (data: any) => {
        this.validatealert = true;
        if (data.data) {
          this.check_moneybox = true;
          this.moneybox = data.data;
        }
      }
    });
  }

  getWarehousePrincipal() {
    this.warehouseService.listPrincipal().subscribe({
      next: (data: any) => {
        this.warehousesSelected = data.results;
      }
    });
  }

  getTypeTransactions() {
    this.generalService.listTypeTransactions().subscribe({
      next: (data: any) => {
        this.transactions = data.results;
        this.item.patchValue({
          typetransaction_id: this.transactions[0].id
        });
        this.transactionSelected = this.transactions[0].id; 
      }
    });
  }

  getTypeVoucherSale() {
    this.generalService.listTypeVoucherSale().subscribe({
      next: (data: any) => {
        this.typevouchers = data.results;
        this.typeVoucherSelected = this.typevouchers[0];
        this.getSerieVoucher(this.typeVoucherSelected.id);
        this.item.patchValue({
          typevoucher_id: this.typeVoucherSelected.id
        });
      }
    });
  }

  getSerieVoucher(typevoucher_id: any) {
    this.generalService.getSerieTypeVoucher(typevoucher_id).subscribe({
      next: (data: any) => {
        this.series = data.results;
        this.serieSelected = this.series[0];
        this.item.patchValue({
          serie: this.serieSelected.series
        });
      }
    });
  }

  changeTypeTransaction(){
    this.transactionSelected = this.item.value.typetransaction_id;
    if(this.transactionSelected == this.transaction_cash){
      this.item.patchValue({
        date_expiration: this.fecha_actual
      });
    }

    if(this.transactionSelected == this.transaction_credit){
      this.item.patchValue({
        date_expiration: moment().add(30, 'day').format('YYYY-MM-DD')
      });
      setTimeout(() => {
        ($('#date_expiration') as any).attr("disabled", true);
      }, 100);
    }

  }

  changeTypeVoucher() {
    let typevoucher_id = this.item.value.typevoucher_id;
    this.isRuc = false;
    if (this.item.value.typevoucher_id == this.typevoucher_factura.id) {
      this.isRuc = true;
    }
    this.getSerieVoucher(typevoucher_id);
  }

  changeCurrency() {
    let obj_ = this.toolsService.searchArrById(
      this.item.value.currency_id,
      this.currencies
    );
    this.currencySelected = obj_;
    console.log(this.currencySelected);
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.item.patchValue({
              currency_id: this.currencies[i].id
            });
            this.currencySelected = this.currencies[i];
          }
        }
      }
    });
  }

  getPaymentmethods() {
    this.generalService.listPaymentmethods().subscribe({
      next: (data: any) => {
        this.paymentmethods = data.results;
        this.changePaymentMethod();
      }
    });
  }

  changePaymentMethod() {
    let obj_ = this.toolsService.searchArrById(
      this.item.value.paymentmethod_id,
      this.paymentmethods
    );
    this.paymentMethodSelected = obj_;

    if (!this.paymentMethodSelected.associate_bank) {
      this.item.patchValue({
        accountbank_id: null,
        reference_operation: null
      });
    }
  }

  changeBankAccount(param: any) {
    let value_ = param.value;
    if (value_ == 'null') {
      value_ = null;
    }
    this.item.patchValue({
      accountbank_id: value_
    });
  }

  selectedClientSearch(item_: any) {
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id,
      tel_1: item_.cellphone,
      tel_2: item_.telephone
    });
  }

  removeClient() {
    this.clientSelected = null;
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  selectedProductSearch(item_: any) {
    item_.is_manual = false;
    item_.detail_id = null;
    item_.quantity = this.quantity_default;
    item_.price = item_.price_sale;
    item_.igv = null;
    item_.warehouse_id = this.warehousesSelected.id;
    item_.segmentpriceproduct_id = this.toolsService.searchObjByKey(
      'price_sale',
      this.segment_prices
    ).id;
    item_.unit_id = item_.unitsmeasure[0].id;

    let subtotal_ = Number(
      Number(item_.price) * Number(item_.quantity)
    ).toFixed(2);
    item_.subtotal = subtotal_;
    this.detail_items.push(item_);
    this.recalculateAmount();
  }

  addProductManual() {
    let item_: any = {};
    item_.is_manual = true;
    item_.code = null;
    item_.description = null;
    item_.quantity = this.quantity_default;
    item_.price = this.quantity_default;
    item_.igv = null;
    item_.warehouse_id = this.warehousesSelected.id;
    item_.segmentpriceproduct_id = this.toolsService.searchObjByKey(
      'price_sale',
      this.segment_prices
    ).id;
    let subtotal_ = Number(
      Number(item_.price) * Number(item_.quantity)
    ).toFixed(2);
    item_.subtotal = subtotal_;
    this.detail_items.push(item_);
    this.recalculateAmount();

    setTimeout(() => {
      this.initialTypeProduct(item_);
      const lastIndex = this.detail_items.length - 1;
      (<any>$('#descriptionProduct' + lastIndex)).focus();
    }, 100);
  }

  initialTypeProduct(item: any) {
    var index = this.detail_items.indexOf(item);
    var options = this.type_products;
    (<any>$('#typeProduct' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#typeProduct' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }

    // valor por defecto es servicios
    (<any>$('#typeProduct' + index)).val(options[1].id);
    this.detail_items[index].type_product = options[1].id;
  }

  changeTypeProduct(param: any, index: number): void {
    this.detail_items[index].type_product = param.value;
  }

  changeDescription(param: any, index: number): void {
    this.detail_items[index].description = param.value;
  }

  changeQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_items[index].quantity = value_;
    }
    this.recalculateAmount();
  }

  changePrice(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_items[index].price = value_;
    }
    this.recalculateAmount();
  }

  recalculateAmount() {
    let total_ = 0;
    for (let i in this.detail_items) {
      let subtotal =
        Number(this.detail_items[i].price) *
        Number(this.detail_items[i].quantity);
      this.detail_items[i].subtotal = Number(subtotal).toFixed(2);
      total_ = total_ + subtotal;
    }
    this.total_amount = Number(total_).toFixed(2);
  }

  removeProduct(id: any, index: any) {
    this.detail_items.splice(index, 1);
    this.recalculateAmount();
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
    }
  }

  addDetailCreditPart() {
    let obj_:any = {};
    obj_.number_quota = null;
    obj_.date_assigned = null;
    obj_.amount_assigned = this.total_amount;
    this.detail_credit_parts.push(obj_);

    this.asignarValorCuotas();
    setTimeout(() => {
      this.initialDateAssignedCreditPart(obj_, this.thisComponent);
    }, 100);
  }

  asignarValorCuotas(){
    if(this.total_amount > 0){
      let cantidad_quotas = this.detail_credit_parts.length;
      let valor_cuota = Number(this.total_amount / cantidad_quotas).toFixed(2);
        for (let i in this.detail_credit_parts) {
          this.detail_credit_parts[i].number_quota = Number(i)+1;
          this.detail_credit_parts[i].amount_assigned = valor_cuota;
        }   
    }    
  }

  initialDateAssignedCreditPart(item: any, component: any) {
    var index = this.detail_credit_parts.indexOf(item);
    this.detail_credit_parts[index].date_assigned = null;
    (<any>$('#date_assigned' + index)).daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        locale: {
          format: 'YYYY-MM-DD'
        }
    }).on('apply.daterangepicker', function(ev:any, picker:any) {
        (<any>$('#date_assigned' + index)).val(picker.startDate.format('YYYY-MM-DD'));
        component.setDateAssigned(index, picker.startDate.format('YYYY-MM-DD'));
    });
  }

  setDateAssigned(index: any, date_assigned: any) {
    this.detail_credit_parts[index].date_assigned = date_assigned;
  }

  changeAmountCreditPart(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_credit_parts[index].amount_assigned = value_;
    }
  }

  removeCreditPart(id: any, index: any) {
    this.detail_credit_parts.splice(index, 1);
    this.asignarValorCuotas();
  }

  savePaid() {
    if (this.validate()) {
      let options = {
        title: '¿Estás segur@?',
        message:
          'Esta seguro(a) de confirmar la emisión del comprobante electrónico?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR EMISIÓN !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    let data: any = {};
    const currencyName = this.currencySelected.currency === 'USD' ? 'Dólares Americanos' : 'Soles';
    this.item.patchValue({
      amount: this.total_amount,
      text_amount: this.amountTextService.letras(
        this.total_amount,
        currencyName, // <- segundo parámetro de la función letras
        true          // <- tercera opción: mayúsculas
      )
    });
    data.income = this.item.value;

    const formData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    // variables send data
    formData.append('item', JSON.stringify(data));
    formData.append('detail_items', JSON.stringify(this.detail_items));
    formData.append('detail_credit_parts', JSON.stringify(this.detail_credit_parts));
    formData.append('url_image', this.fileUrlImage);
    this.voucherService.saveVoucherBilling(formData).subscribe({
      next: (data: any) => {
        var billing = data.billing;
            var label;
            label =
              '<span class="badge badge-success f-s-12 p-5">' +
              billing.message +
              '</span>';

            if (billing.code == 'pending') {
              label =
                '<span class="badge badge-warning f-s-12 p-5">' +
                billing.message +
                '</span>';
            }

            Swal.fire({
              title: 'EN HORA BUENA!',
              html:
                '<b>Venta registrada correctamente</b>, desea imprimir el comprobante?</br></br>' +
                label +
                ' ',
              icon: 'success',
              showCancelButton: true,
              confirmButtonColor: '#30419B',
              cancelButtonColor: '#787171',
              confirmButtonText: 'Imprimir <i class="fas fa-print m-r-5"></i>',
              cancelButtonText: 'Cancelar'
            }).then(result => {
              if (result.isConfirmed) {
                window.open(
                  this.branchofficeSlug +
                  '/api/print/billing/document/voucher/' +
                    data.movement.id
                );
              }
            });
        this.alertifyMsg.success('Registro realizado con éxito');
        this.cancel();
      },
      error: (err: any) => {
        console.error('Error:', err); // Muestra detalles del error en la consola
      }
    });
  }

  validate() {
    if (_.isNull(this.item.value.client_id)) {
      this.alertifyMsg.warning('Debe seleccionar el cliente');
      this.SearchClientComponent.focused();
      return false;
    }

    if (this.isRuc) {
      if (this.clientSelected == null) {
        this.alertifyMsg.warning(
          'Debe especificar el cliente con RUC para el comprobante'
        );
        return false;
      } else {
        if (this.clientSelected.typedocument_id != this.typedocument_ruc.id) {
          let options = {
            title: 'Advertencia !',
            message:
              'El cliente seleccionado DEBE SER CON TIPO DOCUMENTO RUC para la emisión de FACTURAS ELECTRÓNICAS'
          };
          this.alert.warning(options);
          return false;
        }
      }
    }

    if (this.detail_items.length === 0) {
      let options = {
        title: 'Advertencia !',
        message: 'Debe ingresar por lo menos un producto al detalle'
      };
      this.alert.warning(options);
      return false;
    } else {
      for (let i in this.detail_items) {
        let product = this.detail_items[i];
        if(product.is_manual){
          if (!product.description || product.description.trim() === "") {
            this.alertifyMsg.warning("El campo descripción del Producto no puede estar vacío");
            (<any>$('#descriptionProduct' + i)).focus();
            return false;
          }
          // if(_.isNull(product.description) || _.isEmpty(_.trim(product.description))){
          //   this.alertifyMsg.warning("El campo descripción del Producto no puede estar vacío");
          //   (<any>$('#descriptionProduct' + i)).focus();
          //   return false;
          // }
        }

        if (Number(product.quantity) == 0 || _.isNull(product.quantity)) {
          this.alertifyMsg.warning(
            'La cantidad del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#quantity' + i)).focus();
          return false;
        }

        if (Number(product.price) == 0 || _.isNull(product.price)) {
          this.alertifyMsg.warning(
            'El precio del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#price' + i)).focus();
          return false;
        }
      }
    }

    if (this.total_amount == 0) {
      let options = {
        title: 'Advertencia !',
        message: 'El total no puede ser igual a cero'
      };
      this.alert.warning(options);
      return false;
    }

    if(this.transactionSelected == this.transaction_credit_parts){
      if(this.detail_credit_parts.length == 0){
        let options = {
          title: 'Advertencia !',
          message: 'Para la condición de pago con cuotas, debe especificar al menos una cuota'
        };
        this.alert.warning(options);
        return false;
      }else{
        for (let i in this.detail_credit_parts) {
          let numero_cuota = Number(i)+1;
          if(this.detail_credit_parts[i].date_assigned == moment().format('YYYY-MM-DD')){
            let options = {
              title: 'Advertencia !',
              message: 'Las fechas para las cuotas asignadas tienen que ser posterior a la fecha de emisión del comprobante (fecha actual)',
            };
            this.alert.warning(options);
            return false;
          }

          if(this.detail_credit_parts[i].date_assigned == null){
            let options = {
              title: 'Advertencia !',
              message: 'La fecha asignada para la cuota N° '+numero_cuota+' no puede estar vacia',
            };
            this.alert.warning(options);
            return false;
          }

          if(this.detail_credit_parts[i].amount_assigned == null || this.detail_credit_parts[i].amount_assigned == 0){
            let options = {
              title: 'Advertencia !',
              message: 'El monto asignado para la cuota N° '+numero_cuota+' no puede estar vacia o ser igual a 0',
            };
            this.alert.warning(options);
            return false;
          }
        }
      }
      
    }


    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/facturacion/facturas/lista'
    ]);
  }
}
